import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { type PanelManager } from '@databases/panel-types';
import { type DatabaseAdapter, type SelectionsApi } from '@databases/selections-api';
import { type ViewChangeType } from '@databases/utils/database/view/view';

import { buildSelectEntriesActionsForSelectionsAPI } from '../../actions/entries/build-select-entries-actions-for-selections-api';
import { buildSelectFieldsActionsForSelectionsAPI } from '../../actions/fields/build-select-fields-actions-for-selections-api';
import { buildSelectValuesActionsForSelectionsAPI } from '../../actions/values/build-select-values-actions-for-selections-api';
import { type ActionBarActions } from '../action-bar-portal-state';

interface ActionsBuildContext {
  contentId: string;
  selectionsApi: SelectionsApi;
  databaseAdapter: DatabaseAdapter;
  spaceKey: string;
  panelManager: PanelManager;
}

export function buildActionsForSelectionMode(
  mode: 'row' | 'column' | 'cell',
  context: ActionsBuildContext
): ActionBarActions {
  const { contentId, selectionsApi, databaseAdapter, spaceKey, panelManager } = context;

  if (mode === 'row') {
    return buildSelectEntriesActionsForSelectionsAPI({
      contentId,
      selectionsApi,
      view: getCachedViewSnapshotForSelections(),
      databaseAdapter,
      spaceKey,
      panelManager,
    });
  }

  if (mode === 'column') {
    return (setViewChange: (view: ViewChangeType) => void) =>
      buildSelectFieldsActionsForSelectionsAPI({
        contentId,
        selectionsApi,
        databaseAdapter,
        setViewChange,
        view: getCachedViewSnapshotForSelections(),
      });
  }

  return buildSelectValuesActionsForSelectionsAPI({
    contentId,
    selectionsApi,
    panelManager,
  });
}
